module.exports = __webpack_public_path__ + "img/24.bc31b957.gif";